<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :selectedComponent="selectedChartComponent"
    :addButtonText="addButtonText"
    :isNotShowGraph="isNotShowGraph"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    :baselineTitle="baselineRow.title"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow.rows"
    :emptyGridData="emptyGridData"
    :rowOuterButton="rowOuterButton"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    @onChange="OnOptionChange"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceInvestmentFilter, DATETYPE } from "../../helpers/constant";
import { InvestmentAdvanceFilterContent } from "../../mixin";
import {
  GET_SELECTED_INVESTMENT_INFORMATION,
  GET_INVESTMENT_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  computed: {
    ...mapGetters("investment", {
      selectedInvestmentData: GET_SELECTED_INVESTMENT_INFORMATION,
      getInvestmentInformation: GET_INVESTMENT_INFORMATION,
    }),
    legendItems() {
      return ["Base Return", "Return Adjustments"];
    },
    gridButtonTemplate() {
      let difference = true;
      let Investments = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      let ExistingData = Investments[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceInvestmentFilter.Return)
        .map(function (t) {
          let p = {};
          p.amount = t.amount;
          p.amount1 = t.amount1;
          p.amount2 = t.amount2;

          p.description = t.description;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          p.endDate = t.endDate;
          p.endDateType = t.endDateType.toString();
          return p;
        });

      let CurrentDataObject = [];
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            amount: this.rows[i].amount.value,
            amount1: this.rows[i].amount1.value,
            amount2: this.rows[i].amount2.value,

            description: this.rows[i].description.value,
            startDate: this.rows[i].startDate.value,
            startDateType: this.rows[i].startDateType.value.toString(),
            endDate: this.rows[i].endDate.value,
            endDateType: this.rows[i].endDateType.value.toString(),
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
  },
  mixins: [InvestmentAdvanceFilterContent],
  data() {
    return {
      emptyGridData: {
        title: "Click to add Additional Return",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      timeSeriesChartData: this.getTimeSeriesCoordinate(
        this.baselineData.advancedetails,
        AdvanceInvestmentFilter.Return,
        this.baselineData.projectionYear
      ),
      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],

      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },
      contentInfo: {
        heading: "Return",
        subHeading:
          "You can enter in different return at different time periods.",
        infoAlert: {
          title: "Important note",
          variation: "informational",
          text: "You can enter in different return at different time periods.",
        },
      },
      updateButtonText: "Preview Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "",
          fields: [
            "amount",
            "amount1",
            "amount2",

            "startDate",

            "endDate",
            "description",
          ],
          overlapvalidations: false,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "",

      infoError: false,
      singleHeading: "Returns Adjustment",
      headers: [
        {
          type: "FormatInput",
          label: "Income",
          cols: 2,
          key: "amount",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 5,
          max: 99.99,
          validation: false,
          style: {
            width: "120px",
          },
        },
        {
          type: "FormatInput",
          label: "Growth",
          cols: 2,
          key: "amount1",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 5,
          max: 99.99,
          validation: false,
        },
        {
          type: "FormatInput",
          label: "Franking",
          cols: 2,
          key: "amount2",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 5,
          max: 99.99,
          validation: false,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          cols: 1,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: true,
          typing: true,
          label: "End",
          cols: 1,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 1,
          key: "description",
          isAllowOnlyNumber: false,
          appendText: "",
          length: 200,
          validation: false,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
      baselineHeader: this.getEditBaselineHeader(),
      baselineRow: {
        title: "Baseline Return",
        rows: [
          {
            incomeRate: {
              value: this.baselineData.incomeRate,
            },
            growthRate: {
              value: this.baselineData.growthRate,
            },
            frankingRate: {
              value: this.baselineData.frankingRate,
            },
          },
        ],
      },
    };
  },
  mounted() {
    //this.rows = this.fillGrid();
    this.RemapGraphsModel();
  },
  async created() {},
  beforeMount() {
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceInvestmentFilter.Return
    );
  },
  beforeDestroy() {
    this.fillInvestmentModel(AdvanceInvestmentFilter.Return);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceInvestmentFilter.Return
    );
  },

  methods: {
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },
    reset() {
      let Loans = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      let selectedRepData = Loans[0].advancedetails.filter(
        (sr) => sr.typeId == AdvanceInvestmentFilter.Return
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            // EffectiveAsON: {
            //   value: selectedRepData[i].effectiveAsON,
            // },

            amount: {
              value: selectedRepData[i].amount,
            },
            amount1: {
              value: selectedRepData[i].amount1,
            },
            amount2: {
              value: selectedRepData[i].amount2,
            },
            startDate: {
              value: selectedRepData[i].startDate,
              disable:
                selectedRepData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            startDateType: {
              value: selectedRepData[i].startDateType,
            },
            endDate: {
              value: selectedRepData[i].endDate,
              disable:
                selectedRepData[i].endDateType != DATETYPE.Other ? true : false,
            },
            endDateType: {
              value: selectedRepData[i].endDateType,
            },
            description: {
              value: selectedRepData[i].description,
            },
            typeId: {
              value: AdvanceInvestmentFilter.Return,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
        this.getinsertEmptyRows(this.rows);
      }
      this.enableResetButton(false, "reset");
    },
    async UpdateGraph() {
      this.areaChartData = [];
      this.barChartData = [];
      this.fillInvestmentModel(AdvanceInvestmentFilter.Return);
      if (
        !this.validations(
          this.baselineFilterObject.advancedetails,
          AdvanceInvestmentFilter.Return
        )
      ) {
        await this.UpdateGraphModel();
        this.timeSeriesChartData = this.getTimeSeriesCoordinate(
          this.baselineFilterObject.advancedetails,
          AdvanceInvestmentFilter.Return,
          this.baselineData.projectionYear
        );
        this.onChangeChartTab(this.selectedTabComponent);
      }
    },
    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            amount: {
              value: rows[i].amount.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount.disable,
            },
            amount1: {
              value: rows[i].amount1.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount1.disable,
            },
            amount2: {
              value: rows[i].amount2.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount2.disable,
            },
            startDateType: {
              value: rows[i].startDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDateType.disable,
            },
            startDate: {
              value: rows[i].startDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDate.disable,
            },
            endDateType: {
              value: rows[i].endDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDateType.disable,
            },
            endDate: {
              value: rows[i].endDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDate.disable,
            },
            description: {
              value: rows[i].description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].description.disable,
            },
            typeId: {
              value: AdvanceInvestmentFilter.Return,
              IsError: false,
              ErrorText: [],
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? DATETYPE.Other
        : data.endDateType.value;
      let emptyObject = {
        amount: {
          value: IsDataundfined ? "0" : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined ? false : data.amount.disable,
        },
        amount1: {
          value: IsDataundfined ? "0" : data.amount1.value,
          IsError: IsDataundfined ? false : data.amount1.IsError,
          ErrorText: IsDataundfined ? [] : data.amount1.ErrorText,
          disable: IsDataundfined ? false : data.amount1.disable,
        },
        amount2: {
          value: IsDataundfined ? "0" : data.amount2.value,
          IsError: IsDataundfined ? false : data.amount2.IsError,
          ErrorText: IsDataundfined ? [] : data.amount2.ErrorText,
          disable: IsDataundfined ? false : data.amount2.disable,
        },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    fillGrid() {
      let gridRows = [];
      if (this.baselineData.advancedetails != null) {
        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceInvestmentFilter.Return
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        // this.getinsertEmptyRows(gridRows);
      }
      return gridRows;
    },
    getEditBaselineHeader() {
      return [
        {
          type: "Input",
          label: "Income",
          currencyFormat: "",
          appendText: "%",
          key: "incomeRate",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "Input",
          label: "Growth",
          currencyFormat: "",
          appendText: "%",
          key: "growthRate",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "Input",
          label: "Franking",
          currencyFormat: "",
          appendText: "%",
          key: "frankingRate",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "EditButton",
          label: "Edit",
          variation: "flat",
          key: "edit",
          icon: "pencil",
          class: "flexiblePosition",
          cols: 4,
          isdisabled: false,
          align: "center",
          callBackMethod: "editBaseLineButton_Click",
        },
      ];
    },
    editBaseLineButton_Click() {
      this.baselineHeader = [
        {
          type: "Input",
          label: "Income",
          currencyFormat: "",
          appendText: "%",
          key: "incomeRate",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          length: 5,
          max: 99.99,
          class: "",
          cols: 2,
          isdisabled: false,
        },
        {
          type: "Input",
          label: "Growth",
          currencyFormat: "",
          appendText: "%",
          key: "growthRate",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          length: 5,
          max: 99.99,
          class: "",
          cols: 2,
          isdisabled: false,
        },
        {
          type: "Input",
          label: "Franking",
          currencyFormat: "",
          appendText: "%",
          key: "frankingRate",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          length: 5,
          max: 99.99,
          class: "",
          cols: 2,
          isdisabled: false,
        },
        {
          type: "Button",
          label: "Save",
          variation: "primary",
          key: "save",

          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "saveBaseLineButton_Click",
        },
        {
          type: "Button",
          label: "Cancel",
          variation: "flat",
          key: "cancel",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "cancelBaseLineButton_Click",
        },
      ];
    },
    saveBaseLineButton_Click(data) {
      if (
        this.baselineFilterObject.incomeRate != data[0].incomeRate.value ||
        this.baselineFilterObject.growthRate != data[0].growthRate.value ||
        this.baselineFilterObject.frankingRate != data[0].frankingRate.value
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      this.baselineFilterObject.incomeRate = data[0].incomeRate.value;
      this.baselineFilterObject.growthRate = data[0].growthRate.value;
      this.baselineFilterObject.frankingRate = data[0].frankingRate.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    cancelBaseLineButton_Click() {
      this.baselineRow.rows[0].incomeRate.value =
        this.baselineFilterObject.incomeRate;
      this.baselineRow.rows[0].growthRate.value =
        this.baselineFilterObject.growthRate;
      this.baselineRow.rows[0].frankingRate.value =
        this.baselineFilterObject.frankingRate;

      this.baselineHeader = this.getEditBaselineHeader();
    },
  },
};
</script>
<style lang="scss" module></style>
